import Percolator from "./js/helpers/Percolator";
import behaviors from "./js/behaviors";
import {
  AddToCart,
  AnnouncementBar,
  ArticleContent,
  CartItems,
  CookiePreferencesToggle,
  DialogManager,
  FreeShippingProgress,
  GiftRecipientForm,
  LoadMore,
  LocalizationForm,
  NavLink,
  NextMonthTitle,
  PageSelect,
  PredictiveSearch,
  ProductRecommendations,
  QuantityInput,
  RegisterForm,
  RelatedArticles,
  RemoveItem,
  ShowHide,
} from "./js/components";

import "./css/main.css";

const percolator = new Percolator();

percolator.loadBehaviors(behaviors.content);
percolator.loadBehaviors(behaviors.site);

customElements.define("add-to-cart", AddToCart);
customElements.define("announcement-bar", AnnouncementBar);
customElements.define("article-content", ArticleContent);
customElements.define("cart-items", CartItems);
customElements.define("cookie-preferences-toggle", CookiePreferencesToggle);
customElements.define("dialog-manager", DialogManager);
customElements.define("free-shipping-progress", FreeShippingProgress);
customElements.define("gift-recipient-form", GiftRecipientForm);
customElements.define("load-more", LoadMore);
customElements.define("localization-form", LocalizationForm);
customElements.define("nav-link", NavLink);
customElements.define("next-month-title", NextMonthTitle);
customElements.define("page-select", PageSelect);
customElements.define("predictive-search", PredictiveSearch);
customElements.define("product-recommendations", ProductRecommendations);
customElements.define("quantity-input", QuantityInput);
customElements.define("register-form", RegisterForm);
customElements.define("related-articles", RelatedArticles);
customElements.define("remove-item", RemoveItem);
customElements.define("show-hide", ShowHide);
